import React, { useMemo } from 'react';

import { IReturnedCheckDetailsCheckTypeEnum } from '@/dtos';
import { GENERIC_FORM_TYPES, LockboxStatus, LockboxType } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

import LockboxStatusCard from './LockboxStatusCard';

const LockboxCurrentStatus = () => {
  const { originalLockbox, editableLockbox, isDividingMode } = useLockboxDetailsStore();

  const hasStatus = useMemo(() => {
    const lockboxType = originalLockbox?.lockboxType;
    const lockboxStatus = originalLockbox?.lockboxStatus;
    const processingDecisionType = originalLockbox?.details?.processingDecision?.type;
    const checkType = originalLockbox?.details?.checkType;

    if (lockboxType === LockboxType.INBOUND_TOA && (
      lockboxStatus === LockboxStatus.APPROVED
      || lockboxStatus === LockboxStatus.DECLINED
      || lockboxStatus === LockboxStatus.PENDING
      || lockboxStatus === LockboxStatus.COMPLETED
      || lockboxStatus === LockboxStatus.CANCELED
    )) {
      return true;
    }

    if (lockboxType === LockboxType.OUTBOUND_TOA && (
      lockboxStatus === LockboxStatus.APPROVED
      || lockboxStatus === LockboxStatus.DECLINED
      || lockboxStatus === LockboxStatus.PENDING
      || lockboxStatus === LockboxStatus.COMPLETED
      || lockboxStatus === LockboxStatus.CANCELED
    )) {
      return true;
    }

    if (lockboxType === LockboxType.CLAIM_REPAYMENT && (
      lockboxStatus === LockboxStatus.APPROVED
      || lockboxStatus === LockboxStatus.PARTIALLY_APPROVED
      || lockboxStatus === LockboxStatus.DECLINED
      || lockboxStatus === LockboxStatus.PENDING
      || lockboxStatus === LockboxStatus.COMPLETED
      || lockboxStatus === LockboxStatus.CANCELED
    )) {
      return true;
    }

    if (lockboxType && GENERIC_FORM_TYPES.includes(lockboxType) && (
      lockboxStatus === LockboxStatus.PROCESSED_MANUALLY
      || lockboxStatus === LockboxStatus.PENDING
      || lockboxStatus === LockboxStatus.CANCELED
    )) {
      return true;
    }

    if (lockboxType === LockboxType.RETURNED_MAIL && (
      lockboxStatus === LockboxStatus.APPROVED
      || lockboxStatus === LockboxStatus.COMPLETED
      || lockboxStatus === LockboxStatus.PENDING
      || lockboxStatus === LockboxStatus.CANCELED
    )) {
      return true;
    }

    if (lockboxType === LockboxType.RETURNED_CHECK
      && (processingDecisionType === LockboxStatus.VOID
        || processingDecisionType === LockboxStatus.REISSUE
        || checkType === IReturnedCheckDetailsCheckTypeEnum.PARTICIPANT) && (
      lockboxStatus === LockboxStatus.APPROVED
      || lockboxStatus === LockboxStatus.COMPLETED
      || lockboxStatus === LockboxStatus.PROCESSING
    )) {
      return true;
    }

    if (lockboxStatus === LockboxStatus.DIVIDED) {
      return true;
    }

    return false;
  }, [originalLockbox]);

  if (!hasStatus || isDividingMode || (editableLockbox?.isMultipleRecordsWarning && originalLockbox?.lockboxStatus !== LockboxStatus.DIVIDED)) {
    return null;
  }

  return <LockboxStatusCard />;
};

export default LockboxCurrentStatus;
